import { isOpenPartnerIncentiveModal } from "@/atoms/user/is-open-partner-incentive-modal";
import { useRecoilState } from "recoil";
import { PartnerIncentiveModal } from "../modal/PartnerIncentiveModal2";

export const PartnerDetailPageModalPanel = () => {
  const [isPartnerIncentiveModalOpen, setIsPartnerIncentiveModalOpen] =
    useRecoilState(isOpenPartnerIncentiveModal);

  return <>{isPartnerIncentiveModalOpen && <PartnerIncentiveModal />}</>;
};
